// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  color: green;
  font-size: 1.5rem;
}

.custom-row {
  display: inline-flex;
  align-items: center;
}

.dob-row ion-item {
  padding-left: 0;
}

.center-dive {
  margin-right: 10px;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/update-phone-number/update-phone-number.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;AACJ;;AAGI;EACI,eAAA;AAAR;;AAIA;EACI,kBAAA;EACA,WAAA;AADJ","sourcesContent":["ion-icon {\n    color: green;\n    font-size: 1.5rem;\n}\n\n.custom-row{\n    display: inline-flex;\n    align-items: center;\n}\n\n.dob-row {\n    ion-item {\n        padding-left: 0;\n    }\n}\n\n.center-dive {\n    margin-right: 10px;\n    color: #000;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
